import { render, staticRenderFns } from "./tablaCategoria.vue?vue&type=template&id=520ab12a&scoped=true&"
import script from "./tablaCategoria.vue?vue&type=script&lang=js&"
export * from "./tablaCategoria.vue?vue&type=script&lang=js&"
import style0 from "./tablaCategoria.vue?vue&type=style&index=0&id=520ab12a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ab12a",
  null
  
)

export default component.exports